import Parse from "parse";

















export class Video extends Parse.Object {
  constructor(data) {
    super("APP_Video", data );
  }
}

Parse.Object.registerSubclass("APP_Video", Video);
